import { Component, AfterViewInit, EventEmitter, OnInit, Output, ElementRef, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { promise } from 'protractor';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { error } from 'console';
import { finalize } from 'rxjs/operators';
import { ExamEligibilityComponent } from '../exam-eligibility/exam-eligibility.component';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
@Component({
  selector: 'app-qualification-details',
  templateUrl: './qualification-details.component.html',
  styleUrls: ['./qualification-details.component.scss']
})
export class QualificationDetailsComponent implements OnInit, AfterViewInit {
  @Input() tabName: string = '';
  @Output() next = new EventEmitter<void>();
  // @Output() prev = new EventEmitter<void>();
  @Output() prev = new EventEmitter<boolean>();
  @Output() first = new EventEmitter<void>();
  dialogRef: MatDialogRef<any>;
  years: number[] = this.generateYears(1970, new Date().getFullYear());
  fileName: string;
  qualList: any;
  isDivShow: boolean;
  APIService: string;
  disabled = false;
  filteredcourseLevelList: any;
  courseLevelList: any;
  courseList: any;
  filteredcourseList: any;
  filteredboardUniList: any;
  boardUniList: any;
  filteredPassYearList: any;
  PassYearList: any;
  resultNotDec = false;
  tabs: string;
  displayName: any;
  Course: any;
  Faculty: any;
  College: any;
  isSaving: boolean = false;
  uploadedFile
  showotheruni = false;
  fileUploadData: any;
  id: any;
  filename: any;
  prepopulateDataAvailable: boolean = false;
  hideFileInput: boolean = false;
  Noteligible: boolean = true;
  uploadMessage: string;
  showNeet: boolean;
  showCEE = false;
  showPhD = false;
  SnNo: any;
  collegeName: any;
  StuPersonal: any;
  CourseType: string = '';
  // StuSearchCoursequalification: any;
  courseQualificationConfig: any[] = [];
  courseLevelMap: any = {
  '2': '10th',
  '3': '12th',
  '4': 'Diploma',
  '5': 'Degree',
  '8': 'Master',
  '7':'Degree with Honours & Research'
};

neetFields = [
  'StuNeetRgNo',
  'StuNeetRollNo',
  'StuNeetMarksObt',
  'StuNeetMarksTot'
];

ceeFields = [
  'CEEAppNo',
  'CEERollNo',
  'StuCEEMarksObt',
  'StuCEEMarksTot'
];

phdFields = [
  'StuEntranceRollNo',
  'StuEntranceEntrollNo'
];

 private lastProcessedLevel: string | null = null;
 private isApplyingConfig = false;

  OldStudent: boolean;
  selectedCourse: string[];
  isCourseMatched: boolean;
  hasNeetRollNo: any;
  hasNeetAppNo: any;
  hasCeeRollNo: any;
  hasCeeAppNo: any;
  hasNeetMarksObt;
  hasNeetMarksTot;
  hasCeeMarksObt;
  hasCeeMarksTot;
  hasEntranceRollNo: any;
  hasEntranceEntrollNo: any;
  hasEntranceExamType;
  hasEntranceMarksObt;
  hasEntranceMarksTot;
  contactDetails: any;
  courseLeveloptiontwo: any;
  courseLeveloptionone: any;
  highestQualCourseLevel: any;
  IsRegStudent :boolean = false;
  fileExt: string;
  showUpdateRadio:boolean= false;
  showMigrationField = false;

  constructor(private fb: FormBuilder, public dialog: MatDialog,  private router: Router,
    private httpClient: HttpClient,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { this.APIService = environment.serviceUrl; }
  @ViewChild('fileUploader') fileUploader: ElementRef;
  enable = false;
  qualificationDetailsForm: FormGroup;
  submitButton = true;
  nextButton = false;
  updateButton = false;
  deleteButton = false;
  delReadOnly = false;
  resetButton = false;
  errormessage: string;
  uploadDoc: any;
  qualificationDetailsFormArray;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  session = sessionStorage.getItem('session');
  calledApi = 0; // Total number of APIs called
  finishedApi = 0; // Total number of APIs completed (success or failure)
  ngOnInit(): void {
    this.submitButton = true;
    this.hideFileInput = false;
    this.Noteligible = true;
    this.delReadOnly = false;
    this.nextButton = false;
    this.updateButton = false;
    this.resetButton = false;
    this.disabled = false;
    this.showotheruni = false;
    // this.uploadedFile =false
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.session = sessionStorage.getItem('session');
    this.qualificationDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuQualId: new FormControl(),
      otherUni: new FormControl(),
      CheckNote: new FormControl(),
      updateAllQualification: new FormControl('N'),
      StuEntranceRollNo: new FormControl(),
      StuEntranceEntrollNo: new FormControl(),
      Marksheet: new FormControl('N')
    });
    // this.prepopulation();
    this.spinner.show();
    // this.getScrutiny();
    this.getSecretData();
    this.searchCourseQualification(this.Course); 
    this.fetchCourseLevel();
    this.fetchPassYear();
    // this.fetchCourseForQual();
    this.fetchBoardUni();
    this.fetchPersonal();
    this.getApplyData();
    this.loadsettingspage();
    this.prepopulationContact();
    this.getFeeStatus(sessionStorage.getItem('StudentPersonalId'))
    // this.PassYearList = Array.from({ length: 100 }, (_, i) => currentYear - i); // Array for
    // this.filteredPassYearList = this.PassYearList.slice();


  }

searchCourseQualification(courseCode: string) {
  if (!courseCode) return;
    this.highestQualCourseLevel = 0;

  const payload = { CoQcCoCode: courseCode };
  this.umsService.searchCourseQualification(payload).subscribe(res => {
    if (res.status) {
      this.courseQualificationConfig = res.data;
      this.courseLevelList = res.data.map((x: any) => ({
        CdCode: x.CoQcCoLvl,
        CdDesc: this.courseLevelMap[x.CoQcCoLvl] || x.CoQcCoLvl
      }));
       this.courseLevelList.forEach(element => {
          if(element.CdCode > this.highestQualCourseLevel) {
            this.highestQualCourseLevel = element.CdCode ;
          } 
        });
      this.filteredcourseLevelList = [...this.courseLevelList];
    }
  });
}


private lastSelectedCourseLevel: string | null = null;

onCourseLevelChange(level: any) {

  const currentLevel = String(level);

  if (this.isApplyingConfig || this.lastProcessedLevel === currentLevel) {
    return;
  }

  this.lastProcessedLevel = currentLevel;
  this.isApplyingConfig = true;

  console.log('Course level changed:', currentLevel);

  // reset flags FIRST
  this.showNeet = false;
  this.showCEE = false;
  this.showPhD = false;

  // existing logic
  this.CheckOld(currentLevel);

  const config = this.courseQualificationConfig
    ?.find(x => String(x.CoQcCoLvl) === currentLevel);

  if (!config) {
    console.warn('No qualification config found for level:', currentLevel);
    this.isApplyingConfig = false;
    return;
  }

  let formConfig: any;
  try {
    formConfig = JSON.parse(config.CoQcCoFormField);
  } catch (e) {
    console.error('Invalid JSON in CoQcCoFormField');
    this.isApplyingConfig = false;
    return;
  }

  this.applyFormConfig(formConfig);

  // release lock AFTER view stabilizes
  setTimeout(() => {
    this.isApplyingConfig = false;
  });
}



applyFormConfig(formConfig: any) {

  Object.keys(formConfig).forEach(key => {
    if (this.qualificationDetailsFormArray[key]) {
      this.qualificationDetailsFormArray[key][0].FormVisible = formConfig[key];
    }
  });

  // NEET / CEE visibility
  // this.showNeet = !!(
  //   formConfig.StuNeetRgNo ||
  //   formConfig.StuNeetRollNo ||
  //   formConfig.StuNeetMarksObt ||
  //   formConfig.StuNeetMarksTot
  // );

  // this.showCEE = !!(
  //   formConfig.CEEAppNo ||
  //   formConfig.CEERollNo ||
  //   formConfig.StuCEEMarksObt ||
  //   formConfig.StuCEEMarksTot
  // );
}

  fetchPersonal() {
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe(async (res) => {
      if (res.status) {
        this.StuPersonal = res.data[0]
        this.IsRegStudent = !!this.StuPersonal.IsRegStudent;
        this.OldStudent = this.IsRegStudent;
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  ngAfterViewInit(): void {
    // this.loadsettingspage();
    // this.prepopulation();
  }


  getSecretData() {
    this.calledApi++;
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.SnNo = res.projectPharam['SnNo'];
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      };
    });
  }

  getFeeStatus(StuId) {
    const payload = {};
    payload['StuId'] = StuId;
    payload['SnNo'] = this.session;
    this.umsService.getFeeStatus(payload).subscribe(res => {
      if (res.status) {
        console.log('fees status response i get is', res.data);
        this.getScrutiny(StuId)
      }
      else {
        this.disabled = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.disabled = false;
    })
  }

  getScrutiny(StuId) {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['StudentId'] = StuId
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      if (res.status) {
        this.tabs = res.data[0].Tabs;
        if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
          if (res.data[0].Tabs.includes('Qualification Details')) {
            this.disabled = false;
          } else {
            this.disabled = true;
          }
        }
        else {
          this.disabled = true;
        }
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }

    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  onselectPrepopulate(e) {
    // this.qualificationDetailsForm.controls['StuPassYr'].setValue(e['StuPassYr']);
    if ((e['StuCoLvl'] == this.highestQualCourseLevel) && (!this.isCourseMatched) &&this.CourseType !== 'phd') {
      this.showNeet = true;
      this.showCEE = false
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuNeetRollNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setValidators([Validators.required,Validators.max(720)]);
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setValidators([Validators.required,Validators.max(720)]);
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.updateValueAndValidity();

  // Clear CEE fields
  this.qualificationDetailsForm.controls['CEEAppNo']?.markAsUntouched();
  this.qualificationDetailsForm.controls['CEEAppNo']?.setErrors(null);
  this.qualificationDetailsForm.controls['CEEAppNo']?.clearValidators();
  this.qualificationDetailsForm.controls['CEEAppNo']?.setValue('');

  this.qualificationDetailsForm.controls['CEERollNo']?.markAsUntouched();
  this.qualificationDetailsForm.controls['CEERollNo']?.setErrors(null);
  this.qualificationDetailsForm.controls['CEERollNo']?.clearValidators();
  this.qualificationDetailsForm.controls['CEERollNo']?.setValue('');

  this.qualificationDetailsForm.controls['StuCEEMarksObt']?.markAsUntouched();
  this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setErrors(null);
  this.qualificationDetailsForm.controls['StuCEEMarksObt']?.clearValidators();
  this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setValue('');

  this.qualificationDetailsForm.controls['StuCEEMarksTot']?.markAsUntouched();
  this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setErrors(null);
  this.qualificationDetailsForm.controls['StuCEEMarksTot']?.clearValidators();
  this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setValue('');
      if (this.OldStudent == true || this.contactDetails.StuNationality === 'OS') {
        this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsUntouched();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setErrors(null);
        this.qualificationDetailsForm.controls['StuMigrationNo']?.clearValidators();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setValue('');
        this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;

      }
      else {
        this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsTouched();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setValidators(Validators.required);
        this.qualificationDetailsForm.controls['StuMigrationNo']?.updateValueAndValidity();
      }

    }
    else if ((e['StuCoLvl'] == this.highestQualCourseLevel && this.isCourseMatched)) {
      this.showNeet = false;
      this.showCEE = true;
      this.qualificationDetailsForm.controls['CEEAppNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['CEEAppNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['CEEAppNo']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['CEERollNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['CEERollNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['CEERollNo']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setValidators([Validators.required,Validators.max(100)]);
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setValidators([Validators.required,Validators.max(100)]);
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.updateValueAndValidity();
      

  // Clear NEET fields
  this.qualificationDetailsForm.controls['StuNeetRgNo']?.markAsUntouched();
  this.qualificationDetailsForm.controls['StuNeetRgNo']?.setErrors(null);
  this.qualificationDetailsForm.controls['StuNeetRgNo']?.clearValidators();
  this.qualificationDetailsForm.controls['StuNeetRgNo']?.setValue('');

  this.qualificationDetailsForm.controls['StuNeetRollNo']?.markAsUntouched();
  this.qualificationDetailsForm.controls['StuNeetRollNo']?.setErrors(null);
  this.qualificationDetailsForm.controls['StuNeetRollNo']?.clearValidators();
  this.qualificationDetailsForm.controls['StuNeetRollNo']?.setValue('');

  this.qualificationDetailsForm.controls['StuNeetMarksObt']?.markAsUntouched();
  this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setErrors(null);
  this.qualificationDetailsForm.controls['StuNeetMarksObt']?.clearValidators();
  this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setValue('');

  this.qualificationDetailsForm.controls['StuNeetMarksTot']?.markAsUntouched();
  this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setErrors(null);
  this.qualificationDetailsForm.controls['StuNeetMarksTot']?.clearValidators();
  this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setValue('');

      if (this.OldStudent == true || this.contactDetails.StuNationality === 'OS') {
        this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsUntouched();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setErrors(null);
        this.qualificationDetailsForm.controls['StuMigrationNo']?.clearValidators();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setValue('');
        this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;

      }
      else {
        this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsTouched();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setValidators(Validators.required);
        this.qualificationDetailsForm.controls['StuMigrationNo']?.updateValueAndValidity();
      }

    } 
    else{
      if((e['StuCoLvl'] == 8)){
      this.showPhD = true;
      }else{
         this.showPhD = false
      }
      this.showNeet = false;
      this.showCEE = false
      this.qualificationDetailsForm.controls['StuNeetRgNo'].markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetRgNo'].setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetRgNo'].clearValidators();
      this.qualificationDetailsForm.controls['StuNeetRgNo'].setValue('');

      this.qualificationDetailsForm.controls['StuNeetRollNo'].markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetRollNo'].setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetRollNo'].clearValidators();
      this.qualificationDetailsForm.controls['StuNeetRollNo'].setValue('');

      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setValue('');

      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setValue('');

      this.qualificationDetailsForm.controls['CEEAppNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['CEEAppNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['CEEAppNo']?.clearValidators();
      this.qualificationDetailsForm.controls['CEEAppNo']?.setValue('');

      this.qualificationDetailsForm.controls['CEERollNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['CEERollNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['CEERollNo']?.clearValidators();
      this.qualificationDetailsForm.controls['CEERollNo']?.setValue('');

      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.clearValidators();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setValue('');
   
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.clearValidators();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setValue('');

      this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuMigrationNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuMigrationNo']?.clearValidators();
      this.qualificationDetailsForm.controls['StuMigrationNo']?.setValue('');
      if (
      this.qualificationDetailsFormArray &&
      this.qualificationDetailsFormArray['StuMigrationNo'] &&
      this.qualificationDetailsFormArray['StuMigrationNo'][0]
    ) {
      this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;
    }


    }

    console.log('e', e);
    this.fetchCourseName(e.StuCoLvl)
    this.fetchPassYear();
    this.getFeeStatus(e.StuId)
    let base64String: string = e.fileUploadData || '';

    if (e.StuResultStatus == false) {
      this.nextButton = false;
      this.resetButton = false;
    } else {
      this.nextButton = true;
      this.resetButton = true;
    }
    //this.uploadDoc = e.fileUploadData;

    // Store the file data in a component variable
    this.fileUploadData = base64String;  // Store the base64 string for later use

    let mimeType: string = base64String.split(';')[0];
    let fileExtension: string = '';
    if (mimeType.includes('pdf')) {
      fileExtension = 'pdf';
    } else if (mimeType.includes('jpeg') || mimeType.includes('jpg')) {
      fileExtension = 'jpg';
    } else if (mimeType.includes('png')) {
      fileExtension = 'png';
    } else {
      fileExtension = '';
    }

    if (!fileExtension) {
      this.filename = '';
      this.id = null;  // Don't show ID if no file is uploaded
    } else {
      this.id = e.StuQualId;
      this.filename = `${this.id}.${fileExtension}`;
    }
    this.qualificationDetailsForm.controls['fileUploadData'].setErrors(null);
    this.qualificationDetailsForm.controls['fileUploadData'].clearValidators();
    this.qualificationDetailsForm.controls['fileUploadData'].updateValueAndValidity();
    this.prepopulateDataAvailable = true;


    // Show spinner and initialize other variables
    this.spinner.show();
    // this.onSelectionChanged2(e);
    this.submitButton = false;
    this.delReadOnly = false;
    // this.nextButton = true;
    this.updateButton = true;
    this.showUpdateRadio = this.tabs ? this.tabs.includes('Qualification Details') : false;
    this.deleteButton = false;
    // this.resetButton = true;
    this.qualificationDetailsFormArray = [];

    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId']?.setValue(e['StuQualId']);
    this.qualificationDetailsForm.controls['StuCoLvl']?.setValue(e['StuCoLvl']);
    this.qualificationDetailsForm.controls['StuNeetRgNo']?.setValue(e['StuNeetRgNo']);
    this.qualificationDetailsForm.controls['StuNeetRollNo']?.setValue(e['StuNeetRollNo']);
    this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setValue(e['StuNeetMarksObt']);
    this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setValue(e['StuNeetMarksTot']);
    this.qualificationDetailsForm.controls['StuMigrationNo']?.setValue(e['StuMigrationNo']);
    this.showMigrationField = !!e['StuMigrationNo'];
    this.qualificationDetailsForm.controls['CEEAppNo']?.setValue(e['CEEAppNo']);
    this.qualificationDetailsForm.controls['CEERollNo']?.setValue(e['CEERollNo']);
    this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setValue(e['StuCEEMarksObt']);
    this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setValue(e['StuCEEMarksTot']);
    this.qualificationDetailsForm.controls['StuEntranceRollNo']?.setValue(e['StuEntranceRollNo']);
    this.qualificationDetailsForm.controls['StuEntranceEntrollNo']?.setValue(e['StuEntranceEntrollNo']);
    this.onYearSelect(e['StuPassYr'])
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible == true) {
          if (element.FormControlName === 'fileUploadData') {
            // this.qualificationDetailsForm.controls[element.FormControlName].setValue('', Validators.required);
          } else {
            if (element.FormRequired) {
              if (element.FormPattern == '') {
                this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName], Validators.required);
              } else {
                this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]);
              }
            } else {
              this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName]);
            }
          }
        }
      });

this.qualificationDetailsForm.get('Marksheet')?.setValue(e['Marksheet']);
      // Group the data by FormControlName
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
    this.qualificationDetailsForm.controls['StuPassYr'].setValue(e['StuPassYr']);
    this.getStudentEntranceDetails();
  }

  fetchCourseLevel() {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['CdType'] = 'COLVL';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.courseLevelList = res.data;
        this.filteredcourseLevelList = this.courseLevelList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }


  fetchPassYear() {
    // this.calledApi++; // Increment the called API count
    const currentYear = new Date().getFullYear();
    this.PassYearList = Array.from({ length: 100 }, (_, i) => {
      const year = currentYear - i;
      return { year, description: `Year ${year}` };
    });
    this.filteredPassYearList = [...this.PassYearList];
    // this.finishedApi++; // Increment the finished API count
    // if (this.finishedApi === this.calledApi) {
    //   this.spinner.hide();
    // }
  }

  onYearSelect(year2: number) {
    if (!this.PassYearList.some(y => y.year === year2)) {
      this.PassYearList.push({ year: year2, description: `Year ${year2}` });
    }
    this.filteredPassYearList = Array.from(new Set(this.PassYearList.map(y => y.year)))
      .map(year => this.PassYearList.find(y => y.year === year)!);

    this.qualificationDetailsForm.controls['StuPassYr'].setValue(year2);

  }

    fetchCourseForQual(event: MatSelectChange): void {

  const level = Number(event.value);
  const highestLevel = Number(this.highestQualCourseLevel);

  // Default reset
  this.showNeet = false;
  this.showCEE = false;
  this.showPhD = false
  this.showotheruni = false;
  this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;
if (this.CourseType == 'phd' && level===highestLevel) {
    this.showPhD = true;
}
  // NEET Condition
  else if (level === highestLevel && !this.isCourseMatched) {
    this.showNeet = true;
  }

  // CEE Condition
  else if ([3, 4, 5].includes(level) && this.isCourseMatched) {

  this.showCEE = true;

    // Migration Required
    // if (level === 4 && this.Course === 'PB-53') {
    //   this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = true;
    // }

    // Other University
    if (
      (level === 4 || level === 5) &&
      (this.Course === 'PB-53' || this.Course === 'MN-52')
    ) {
      this.showotheruni = true;
      this.qualificationDetailsForm.controls['StuUniversity']?.setValue('');
    }
  }

  // Reset Block
  else {
    const resetFields = [
      'StuNeetRgNo',
      'StuNeetRollNo',
      'StuNeetMarksObt',
      'StuNeetMarksTot',
      'CEEAppNo',
      'CEERollNo',
      'StuCEEMarksObt',
      'StuCEEMarksTot',
      'StuMigrationNo'
    ];

    resetFields.forEach(field => {
      this.qualificationDetailsForm.controls[field]?.markAsUntouched();
      this.qualificationDetailsForm.controls[field]?.setErrors(null);
      this.qualificationDetailsForm.controls[field]?.clearValidators();
      this.qualificationDetailsForm.controls[field]?.setValue('');
    });
  }

  // COURSE FETCH LOGIC

  const selectedCode = event.value;
  this.qualificationDetailsForm.controls['StuCoName'].setValue('');
  let payload = { CdType: 'Cours' };

  if (selectedCode === 'UG') {
    payload = { CdType: 'UGCo' };
  } 
  else if (selectedCode === 'PG') {
    payload = { CdType: 'PGCo' };
  } 
  else if (selectedCode === '2') {
    payload = { CdType: 'HSLC' };
  } 
  else if (selectedCode === '3' || selectedCode === '4' || selectedCode === '5') {
    payload = { CdType: 'AHSEC' };
  }

  this.umsService.fetchCodeType(payload).subscribe((res) => {
    if (res.status) {
      this.courseList = res.data;

      if (['UG', 'PG', '2', '3'].includes(selectedCode)) {
        this.filteredcourseList = this.courseList;
      } else {
        this.updateFilteredCourses(selectedCode);
      }
    } else {
      this.filteredcourseList = [];
      this.courseList = [];
      console.error('Error fetching course data:', res.message);
    }
  });
}

  fetchCourseName(level): void {
    const selectedCode = level; // Selected value from StuCoLvl
    // this.qualificationDetailsForm.controls['StuCoLvl'].setValue(level);
    let payload = { CdType: 'Cours' }; // Default payload for 1, 2, and 3

    // Adjust payload based on selected code
    if (selectedCode === 'UG') {
      payload = { CdType: 'UGCo' }; // Use UGCo for UG
    } else if (selectedCode === 'PG') {
      payload = { CdType: 'PGCo' }; // Use PGCo for PG
    }
    else if (selectedCode == '2') {
      payload = { CdType: 'HSLC' }; // Use HS for HS
    }
    else if (selectedCode == '3') {
      payload = { CdType: 'AHSEC' };
    }

    // Fetch data based on the payload
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.courseList = res.data;

        // Update the filtered list based on selection
        if (selectedCode === 'UG' || selectedCode === 'PG' || selectedCode == '2' || selectedCode === '3') {
          this.filteredcourseList = this.courseList; // For UG and PG, show all results from API
        } else {
          this.updateFilteredCourses(selectedCode); // For 1, 2, and 3, filter as before
        }
      } else {
        // Handle error or show a message
        this.filteredcourseList = [];
        this.courseList = [];
        console.error('Error fetching course data:', res.message);
      }
    });
  }

  private updateFilteredCourses(selectedCode: any): void {
    if (selectedCode) {
      this.filteredcourseList = this.courseList.filter((item) => {
        if (selectedCode == 1) return item.CdCode === 'SSC';
        if (selectedCode == 2) return item.CdCode === 'HSC';
        if (selectedCode == 3) return item.CdCode === 'DIP';
        return false; // For unmatched cases
      });
    } else {
      // Retain the last filtered list if no selection is made
    }
  }

  fetchBoardUni() {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['CdType'] = 'BOARD';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.boardUniList = res.data;
        this.filteredboardUniList = this.boardUniList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }
  prepopulation() {
    // remove aftre it work
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {

      if (res.status) {
        res.data.StuCgpi = parseFloat(res.data.StuCgpi);
        res.data.StuPassYr = parseInt(res.data.StuPassYr);
        // if(res.da)
        if (res.data.length > 0) {
          // sessionStorage.setItem("StudentPersonalId",res.data[0].StuId);
          this.submitButton = false;
          this.delReadOnly = false;
          this.updateButton = true;
          this.nextButton = true;
          this.Noteligible = true;
          this.deleteButton = false;
          this.resetButton = true;
          this.qualificationDetailsForm.get('Marksheet')?.setValue(
 res.data[0].FieldValue
  );
          this.prepopulatedatapage(res);
        } else {
          this.loadsettingspage();
        }
      } else {
        this.loadsettingspage();
      }
    })
  }

  prepopulatedatapage(e) {
    // remove omnce done 
    // alert("called QualifyDetails")
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e.data[0]['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

            } else {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
            else {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.pattern(element.FormPattern)]));
            }
          }
        } else {
          this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });

    this.fetchQualDetailsForTable();
  }


  loadsettingspage() {
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.umsService.getStdSetting(payload).subscribe(async (res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', Validators.required)
              );
            } else {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)])
              );
            }

          } else {

            if (element.FormPattern == '') {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }
          }
        }
      });
      this.qualificationDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
      await this.fetchQualDetailsForTable();
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }

    }

    );


  }



  onChange($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;

    this.filename = '';  // Clear the filename
    this.fileUploadData = '';
    this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
      if (this.qualificationDetailsForm.get('StuCoLvl')?.value == 7) {
      this.qualificationDetailsForm.patchValue({
        fileUploadData1: d
      });
    } else {
      this.qualificationDetailsForm.patchValue({
        fileUploadData: d
      });
    }

    });
  }
  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  onSelectionChangedForDecResu(value) {
    if (value === 1) {
      this.resultNotDec = false;

      this.qualificationDetailsForm.controls['StuMarksObt'].setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();


      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].setValidators(Validators.required);
      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuPassYr'].setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksTot'].setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuClass'].setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();
      // this.qualificationDetailsForm.get('StuPassYr').markAsUntouched();

    } else {
      this.resultNotDec = true;
      this.qualificationDetailsForm.controls['StuPassYr'].setValue('');

      this.qualificationDetailsForm.controls['StuPassYr'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPassYr'].clearValidators();
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].setErrors(null);
      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].clearValidators();
      // this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksObt'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksObt'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksTot'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksTot'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuClass'].setErrors(null);
      this.qualificationDetailsForm.controls['StuClass'].clearValidators();
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarkListRgNo'].setValue('')
      this.qualificationDetailsForm.get('StuMarkListRgNo').markAsUntouched();
      this.qualificationDetailsForm.controls['StuMarksObt'].setValue('')
      this.qualificationDetailsForm.get('StuMarksObt').markAsUntouched();

      this.qualificationDetailsForm.controls['StuMarksTot'].setValue('')
      this.qualificationDetailsForm.get('StuMarksTot').markAsUntouched();

      this.qualificationDetailsForm.controls['StuPercent'].setValue('')
      this.qualificationDetailsForm.get('StuPercent').markAsUntouched();

      this.qualificationDetailsForm.controls['StuCgpi'].setValue('')
      this.qualificationDetailsForm.get('StuCgpi').markAsUntouched();

      this.qualificationDetailsForm.controls['StuClass'].setValue('')
      this.qualificationDetailsForm.get('StuClass').markAsUntouched();

      this.qualificationDetailsForm.controls['fileUploadData'].setValue('')

    }
  }

  onSelectionChanged2(value) {
    if (value = 2) {
      this.resultNotDec = true;
      this.qualificationDetailsForm.get('fileUploadData').markAsUntouched();
      this.qualificationDetailsForm.get('StuPassYr').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarkListRgNo').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksObt').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksTot').markAsUntouched();
      this.qualificationDetailsForm.get('StuPercent').markAsUntouched();
      this.qualificationDetailsForm.get('StuCgpi').markAsUntouched();
      this.qualificationDetailsForm.get('StuClass').markAsUntouched();
      this.qualificationDetailsForm.controls['StuPassYr'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPassYr'].clearValidators();
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarkListRgNo'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksObt'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksObt'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksTot'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksTot'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuPercent'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPercent'].clearValidators();
      this.qualificationDetailsForm.controls['StuPercent'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuCgpi'].setErrors(null);
      this.qualificationDetailsForm.controls['StuCgpi'].clearValidators();
      this.qualificationDetailsForm.controls['StuCgpi'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuClass'].setErrors(null);
      this.qualificationDetailsForm.controls['StuClass'].clearValidators();
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['fileUploadData'].setErrors(null);
      this.qualificationDetailsForm.controls['fileUploadData'].clearValidators();
      this.qualificationDetailsForm.controls['fileUploadData'].updateValueAndValidity();

    } else {
      this.resultNotDec = false;
    }
  }

  onSelectionChanged3(value) {
    this.delReadOnly = true;
    this.resultNotDec = true;
  }
  SubmitFormarkAsTouched() {
    if ((this.qualificationDetailsForm.value.StuCoLvl == this.highestQualCourseLevel) && (!this.isCourseMatched)) {
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuNeetRollNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setValidators([Validators.required,Validators.max(720)]);
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setValidators([Validators.required,Validators.max(720)]);
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['CEEAppNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['CEEAppNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['CEEAppNo']?.clearValidators();
      this.qualificationDetailsForm.controls['CEEAppNo']?.setValue('');
       this.qualificationDetailsFormArray['CEEAppNo'][0]['FormRequired'] = false;

      this.qualificationDetailsForm.controls['CEERollNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['CEERollNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['CEERollNo']?.clearValidators();
      this.qualificationDetailsForm.controls['CEERollNo']?.setValue('');
       this.qualificationDetailsFormArray['CEERollNo'][0]['FormRequired'] = false;

      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.clearValidators();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setValue('');
      this.qualificationDetailsFormArray['StuCEEMarksObt'][0]['FormRequired'] = false;

      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.clearValidators();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setValue('');
      this.qualificationDetailsFormArray['StuCEEMarksTot'][0]['FormRequired'] = false;

      if (this.OldStudent == true || this.contactDetails.StuNationality === 'OS' || this.CourseType == 'phd') {
        this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsUntouched();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setErrors(null);
        this.qualificationDetailsForm.controls['StuMigrationNo']?.clearValidators();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setValue('');
        this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;

      }
      else {
        this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsTouched();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setValidators(Validators.required);
        this.qualificationDetailsForm.controls['StuMigrationNo']?.updateValueAndValidity();
      }


    }
    else if ((this.qualificationDetailsForm.value.StuCoLvl == this.highestQualCourseLevel) && (this.isCourseMatched)) {
      this.qualificationDetailsForm.controls['CEEAppNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['CEEAppNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['CEEAppNo']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['CEERollNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['CEERollNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['CEERollNo']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setValidators([Validators.required,Validators.max(100)]);
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setValidators([Validators.required,Validators.max(100)]);
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuNeetRgNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.setValue('');
       this.qualificationDetailsFormArray['StuNeetRgNo'][0]['FormRequired'] = false;

      this.qualificationDetailsForm.controls['StuNeetRollNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.setValue('');
       this.qualificationDetailsFormArray['StuNeetRollNo'][0]['FormRequired'] = false;

      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setValue('');
      this.qualificationDetailsFormArray['StuNeetMarksObt'][0]['FormRequired'] = false;

      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setValue('');
      this.qualificationDetailsFormArray['StuNeetMarksTot'][0]['FormRequired'] = false;

      if ((this.OldStudent == true || this.contactDetails.StuNationality === 'OS')) {
        this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsUntouched();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setErrors(null);
        this.qualificationDetailsForm.controls['StuMigrationNo']?.clearValidators();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setValue('');
        this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;

      }
      else {
        this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsTouched();
        this.qualificationDetailsForm.controls['StuMigrationNo']?.setValidators(Validators.required);
        this.qualificationDetailsForm.controls['StuMigrationNo']?.updateValueAndValidity();
      }


    } 
    else {
      this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuMigrationNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuMigrationNo']?.clearValidators();
      this.qualificationDetailsForm.controls['StuMigrationNo']?.setValue('');
      this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;

      this.qualificationDetailsForm.controls['StuNeetRgNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.setValue('');

      this.qualificationDetailsForm.controls['StuNeetRollNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.setValue('');

      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.setValue('');

      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.setValue('');

      this.qualificationDetailsForm.controls['CEEAppNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['CEEAppNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['CEEAppNo']?.clearValidators();
      this.qualificationDetailsForm.controls['CEEAppNo']?.setValue('');

      this.qualificationDetailsForm.controls['CEERollNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['CEERollNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['CEERollNo']?.clearValidators();
      this.qualificationDetailsForm.controls['CEERollNo']?.setValue('');

      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.clearValidators();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.setValue('');

      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.clearValidators();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.setValue('');

      this.qualificationDetailsForm.controls['StuMigrationNo']?.markAsUntouched();
      this.qualificationDetailsForm.controls['StuMigrationNo']?.setErrors(null);
      this.qualificationDetailsForm.controls['StuMigrationNo']?.clearValidators();
      this.qualificationDetailsForm.controls['StuMigrationNo']?.setValue('');
      this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;

    }

    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.qualificationDetailsForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
            }
          }
        }
      });
      this.qualificationDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }

  SubmitQualificationDetails() {
    if (this.IsRegStudent) {
  this.qualificationDetailsForm.controls['StuMigrationNo']?.clearValidators();
  this.qualificationDetailsForm.controls['StuMigrationNo']?.setErrors(null);
  this.qualificationDetailsForm.controls['StuMigrationNo']?.updateValueAndValidity();

  if (this.qualificationDetailsFormArray?.['StuMigrationNo']?.[0]) {
    this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;
  }
}
    if(this.qualificationDetailsForm.value.StuCEEMarksObt > 100) {
      this.qualificationDetailsForm.get('StuCEEMarksObt').setErrors({ max: true });
      this.qualificationDetailsForm.get('StuCEEMarksObt').markAsTouched();
    }
      if(!this.showCEE){
      this.qualificationDetailsForm.controls['CEEAppNo'].clearValidators();
      this.qualificationDetailsForm.controls['CEERollNo'].clearValidators();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.clearValidators();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.clearValidators();
      this.qualificationDetailsForm.controls['CEEAppNo']?.updateValueAndValidity();
      this.qualificationDetailsForm.controls['CEERollNo']?.updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuCEEMarksObt']?.updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuCEEMarksTot']?.updateValueAndValidity();
    }
    if(!this.showNeet){
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.clearValidators();
      this.qualificationDetailsForm.controls['StuNeetRgNo']?.updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuNeetRollNo']?.updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuNeetMarksObt']?.updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuNeetMarksTot']?.updateValueAndValidity();
    }
    if(this.showPhD){
      this.qualificationDetailsForm.controls['StuEntranceRollNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuEntranceRollNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuEntranceRollNo']?.updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuEntranceEntrollNo']?.markAsTouched();
      this.qualificationDetailsForm.controls['StuEntranceEntrollNo']?.setValidators(Validators.required);
      this.qualificationDetailsForm.controls['StuEntranceEntrollNo']?.updateValueAndValidity();
      this.qualificationDetailsForm.get('fileUploadData1')?.clearValidators();
      this.qualificationDetailsForm.get('fileUploadData1')?.setErrors(null);
      this.qualificationDetailsForm.get('fileUploadData1')?.updateValueAndValidity();
      
    }
    if (!this.showMigrationField) {
  const migrationControl = this.qualificationDetailsForm.get('StuMigrationNo');
  migrationControl?.clearValidators();
  migrationControl?.setErrors(null);
  migrationControl?.updateValueAndValidity();
}
if (this.qualificationDetailsForm.get('StuCoLvl')?.value != 7) {
  this.qualificationDetailsForm.get('fileUploadData1')?.clearValidators();
  this.qualificationDetailsForm.get('fileUploadData1')?.setErrors(null);
  this.qualificationDetailsForm.get('fileUploadData1')?.setValue('');
  this.qualificationDetailsForm.get('fileUploadData1')?.updateValueAndValidity();
}
    if (this.qualificationDetailsForm.invalid) {
      console.log('this.qualificationDetailsForm',this.qualificationDetailsForm)
       Object.keys(this.qualificationDetailsForm.controls).forEach(key => {
      const control = this.qualificationDetailsForm.get(key);
      if (control && control.invalid && control.enabled && control.hasError('max')) {
        console.log(`❌ Invalid Field: ${key}`, control.errors);
        control.markAsTouched(); 
        control.updateValueAndValidity({ onlySelf: true });
      }
    });
      this.SubmitFormarkAsTouched();
    } else {
      // this.checkEligibility()
      this.Submit()
    }
  }

  async Submit() {
    this.isSaving = true;
    this.spinner.show();
    let payload = this.qualificationDetailsForm.value;
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    payload.StuId = parseInt(payload.StuId);
    payload.StuCoLvl = payload.StuCoLvl;
    payload.StuQualStr = parseInt(payload.StuQualStr);
    payload.StuPassYr = parseInt(payload.StuPassYr);
    payload.StuMarksObt = parseInt(payload.StuMarksObt);
    payload.StuMarksTot = parseInt(payload.StuMarksTot);
    const savefile = await this.saveFiles();
    payload.fileUploadData = savefile?.file || this.fileUploadData;
    payload['StuId'] = this.StudentPersonalId;
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    console.log('payload',payload)
    this.umsService.addQualificationDetails(payload).subscribe(res => {
      if (res.status) {
        this.saveMarksheet()
        this.saveEntranceDetails()
        this.isSaving = false;
        this.spinner.hide();
        this.fetchQualDetailsForTable();
        this.qualificationDetailsForm.reset();
        this.fileUploader.nativeElement.value = null;
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.checkEligibility('submit')
        })
      }
      else {
        this.isSaving = false;
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.isSaving = false;
      this.spinner.hide();
    });
  }

  // getTabName() {
  //   this.displayName = this.tabName;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }

  UpdateQualificationDetails() {
 if (this.updateButton) {
    this.qualificationDetailsForm.get('fileUploadData1')?.clearValidators();
    this.qualificationDetailsForm.get('fileUploadData1')?.updateValueAndValidity();
}

  if (this.IsRegStudent) {
  this.qualificationDetailsForm.controls['StuMigrationNo']?.clearValidators();
  this.qualificationDetailsForm.controls['StuMigrationNo']?.setErrors(null);
  this.qualificationDetailsForm.controls['StuMigrationNo']?.updateValueAndValidity();

  if (this.qualificationDetailsFormArray?.['StuMigrationNo']?.[0]) {
    this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;
  }
}

    if (this.qualificationDetailsForm.invalid) {
      this.SubmitFormarkAsTouched();

    } else {
      //  this.checkEligibility()
      const form = this.qualificationDetailsForm;
      const stuCoLvl = this.qualificationDetailsForm.getRawValue().StuCoLvl;
      const isOldStudent = this.OldStudent;
      let hasValidationErrors = false; // custom flag

      // Apply validators based on StuCoLvl
      if (( this.CourseType !== 'phd' && stuCoLvl == this.highestQualCourseLevel) && !this.isCourseMatched) {
        const rgNo = form.controls['StuNeetRgNo'];
        rgNo.setValidators(Validators.required);
        rgNo.updateValueAndValidity();
        if (!rgNo.value) {
          rgNo.markAsTouched();
          hasValidationErrors = true;
        }

        // NEET Roll No
        const rollNo = form.controls['StuNeetRollNo'];
        rollNo.setValidators(Validators.required);
        rollNo.updateValueAndValidity();
        if (!rollNo.value) {
          rollNo.markAsTouched();
          hasValidationErrors = true;
        }

        // NEET Marks Obtained
        const marksObtained = form.controls['StuNeetMarksObt'];
        marksObtained.setValidators([Validators.required,Validators.max(720)]);
        marksObtained.updateValueAndValidity();
        if (!marksObtained.value) {
          marksObtained.markAsTouched();
          hasValidationErrors = true;
        }

        // NEET Marks Total
        const marksTotal = form.controls['StuNeetMarksTot'];
        marksTotal.setValidators([Validators.required,Validators.max(720)]);
        marksTotal.updateValueAndValidity();
        if (!marksTotal.value) { 
          marksTotal.markAsTouched();
          hasValidationErrors = true;
        }

        // Migration No (only if NOT old student)
      //   const migrationNo = form.controls['StuMigrationNo'];
      //   if (!isOldStudent) {
      //     migrationNo.setValidators(Validators.required);
      //     migrationNo.updateValueAndValidity();
      //     if (!migrationNo.value) {
      //       migrationNo.markAsTouched();
      //       hasValidationErrors = true;
      //     }
      //     this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = true;
      //   }
      // }
      // Apply validators based on StuCoLvl
      else if (stuCoLvl == this.highestQualCourseLevel && this.isCourseMatched) {
        const appNo = form.controls['CEEAppNo'];
        appNo.setValidators(Validators.required);
        appNo.updateValueAndValidity();
        if (!appNo.value) {
          appNo.markAsTouched();
          hasValidationErrors = true;
        }

        // NEET Roll No
        const ceeRNo = form.controls['CEERollNo'];
        ceeRNo.setValidators(Validators.required);
        ceeRNo.updateValueAndValidity();
        if (!ceeRNo.value) {
          ceeRNo.markAsTouched();
          hasValidationErrors = true;
        }

        // CEE Marks Obtained
        const ceeMarksObt = form.controls['StuCEEMarksObt'];
        ceeMarksObt.setValidators([Validators.required,Validators.max(100)]);
        ceeMarksObt.updateValueAndValidity();
        if (!ceeMarksObt.value) {
          ceeMarksObt.markAsTouched();
          hasValidationErrors = true;
        }

        // CEE Marks Total
        const ceeMarksTot = form.controls['StuCEEMarksTot'];
        ceeMarksTot.setValidators([Validators.required,Validators.max(100)]);
        ceeMarksTot.updateValueAndValidity();
        if (!ceeMarksTot.value) {
          ceeMarksTot.markAsTouched();
          hasValidationErrors = true;
        }

        // Migration No (only if NOT old student)
      //   const migrationNo = form.controls['StuMigrationNo'];
      //   if (!isOldStudent) {
      //     migrationNo.setValidators(Validators.required);
      //     migrationNo.updateValueAndValidity();
      //     if (!migrationNo.value) {
      //       migrationNo.markAsTouched();
      //       hasValidationErrors = true;
      //     }
      //     this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = true;
      //   }
      // }

      //       console.log('hasValidationErrors', hasValidationErrors);
//             console.log(
//                 Object.keys(this.qualificationDetailsForm.controls)
//                   .filter(key => this.qualificationDetailsForm.get(key)?.invalid)
//                   );

      // Final decision
      if (!hasValidationErrors) {
        console.log('im valid i will call update api');

        this.UpdateConfirmation();
      } else {
        this.SubmitFormarkAsTouched(); // optionally highlight all controls
      }
    }

  }
}
  }

  UpdateConfirmation() {
      this.UpdateScrutiny();
  }



  async UpdateScrutiny() {
    this.spinner.show();
    let payload = this.qualificationDetailsForm.getRawValue();
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    payload.StuId = parseInt(payload.StuId);
    payload.StuCoLvl = payload.StuCoLvl;
    payload.StuQualStr = parseInt(payload.StuQualStr);
    payload.StuPassYr = parseInt(payload.StuPassYr);
    // payload.StuMarkListRgNo =parseInt(payload.StuMarkListRgNo);
    //  payload.StuSeatNo =parseInt(payload.StuSeatNo);
    payload.StuMarksObt = parseInt(payload.StuMarksObt);
    payload.StuMarksTot = parseInt(payload.StuMarksTot);
    //payload.StuCgpi =parseFloat(payload.StuCgpi);
    // payload.StuRgNo =parseInt(payload.StuRgNo);
    const savefile = await this.saveFiles();
    payload.fileUploadData = savefile?.file || this.fileUploadData;
    payload['StuId'] = this.StudentPersonalId;
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    this.umsService.updateQualificationDetails(payload).subscribe(res => {
      if (res.status) {
        this.saveMarksheet()
      this.saveEntranceDetails();
      this.umsService.setTabSaved('qualificationTab');
      const canUpdateScrutiny =
        this.tabs &&
        this.umsService.isRequiredTabsSaved(this.tabs);
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.checkEligibility('update')
        })
        const updateAll = this.qualificationDetailsForm.get('updateAllQualification')?.value;
        if (this.showUpdateRadio) {
          if (updateAll === 'Y') {
            // this.UpdScrtDetails();
        if (canUpdateScrutiny) {
  const data = {};
  data['message'] =
    'Are You Sure You Have Updated ' +
    this.tabs +
    ' Tabs. Do You Want To Proceed?';

  data['title'] = 'Alert';
  data['icon'] = 'fa fa-question';

  this.dialogRef =
    this.modalPopupService.openPopup<ConformationModelComponent>(
      ConformationModelComponent,
      data
    );
  this.dialogRef.afterClosed().subscribe(result => {
    if (result === 'yes') {
      this.UpdScrtDetails();
        if (this.tabs?.includes('Wrong Payment')) {
      this.router.navigate(['/Fees']);
      }
    }
  });
}
  this.spinner.hide();
            return;
          }
          this.fetchQualDetailsForTable();
          this.updateButton = true;
          this.spinner.hide();
          return;
        }
        //  this.UpdScrtDetails();
        this.qualificationDetailsForm.reset({updateAllQualification: 'N'});
        this.resultNotDec = false;
        this.submitButton = true;
        this.delReadOnly = false;
        this.nextButton = true;
        this.updateButton = false;
        this.deleteButton = false;
        this.resetButton = false;
        this.uploadedFile = false;
        this.fileUploader.nativeElement.value = null;
        this.fetchQualDetailsForTable();
        // this.umsService.openSnackbar(res.message)
        //this.ngOnInit();
        //this.next.emit();
      }
    },
    );
  }
  UpdScrtDetails() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        this.first.emit();
        location.reload();
      }
      else {

      }
    })
  }
  getApplyData() {
    this.calledApi++; // Increment the called API count
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    //  this.selectedCourse = ['BIT14']; 
    this.umsService.getApplyData(payload).subscribe((res) => {
      if (res.status) {
        this.Course = res.data[0]['Course'];
        this.Faculty = res.data[0].FcCode;
        console.log('Course from API:', this.Course);
      if (this.Course) {
        this.searchCourseQualification(this.Course);
      }
        const upperCaseCourse = this.Course?.toUpperCase();
        this.selectedCourse = ['BN-53', 'BIT14', '1010', 'PY-63', 'DP-66', 'PB-53', 'MN-52'];
        this.isCourseMatched = this.selectedCourse.includes(upperCaseCourse);

        this.College = res.data[0]['College'];
        this.getcollege(res.data[0]['College'])
         this.getCourseType();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }
getCourseType() {
  this.spinner.show();
  const payload = {};
  payload['CoCode'] = this.Course;
  this.umsService.fetchCourseType(payload).subscribe(res => {
    if (res.status) {
      this.spinner.hide();
      this.CourseType = res.data[0].CourseLevel;
    } else {
      this.spinner.hide();
    }
  }, (ERROR: HttpErrorResponse) => {
    this.spinner.hide();
  });
}
  prepopulationOneDetails() {
    this.submitButton = false;
    this.delReadOnly = false;
    this.updateButton = true;
    this.nextButton = true;
    this.Noteligible = true;
    let payload = {};
    let xyz = this.qualificationDetailsForm.value.StuQualStr;
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      //  this.onSelectionChanged(xyz);
      if (res.status) {
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);

          this.prepopulatedatapage(res);
        } else {
          this.loadsettingspage();
        }
      } else {
        this.loadsettingspage();
      }
    })
  }

  fetchQualDetailsForTable() {
    this.showNeet = false;
    this.showCEE = false;
    this.hasNeetRollNo = false;
    this.hasNeetAppNo = false;
    this.hasEntranceRollNo = false;
    this.hasEntranceEntrollNo = false;
    this.hasCeeRollNo = false;
    this.hasCeeAppNo = false;
    this.hasNeetMarksObt = false;
    this.hasNeetMarksTot = false;
    this.hasEntranceMarksObt = false;
    this.hasEntranceMarksTot = false;
    this.hasCeeMarksObt = false;
    this.hasCeeMarksTot = false;
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['StuQualId'] = '';
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.qualList = res.data;
        this.qualList.forEach((item: any) => {
          item.isViewable = false;
          if (!item.fileUploadData) {
            return;
          }
          this.umsService.fetchDocument({ filePath: item.fileUploadData, viewFile: true }).subscribe(
            (docRes: any) => {
              item.isViewable = docRes.isViewable;
            },
            () => {
              item.isViewable = false;
            }
          );
        });
        this.courseLeveloptionone = res.data[0]['StuCourseLevel'];
        this.courseLeveloptiontwo = res?.data[1]?.StuCourseLevel;
        if(res?.data[0]['StuCourseLevel'] && res?.data[this.courseLevelList?.length-1]?.StuCourseLevel) {
           this.qualificationDetailsForm.get('StuCoLvl')?.disable();
        } else {
          this.qualificationDetailsForm.get('StuCoLvl')?.enable();
        }
        if (res.data.length == 0) {
          this.isDivShow = false;
          this.nextButton = false;
        }
        else {

          // this.umsService.disable4 = false;
          this.isDivShow = true;
          this.nextButton = true;
          this.Noteligible = true;
                    // Set flags based on presence of data in any row
          this.hasNeetRollNo = this.qualList.some(q => !!q.StuNeetRollNo);
          this.hasNeetAppNo = this.qualList.some(q => !!q.StuNeetRgNo);
          this.hasNeetMarksObt = this.qualList.some(q => !!q.StuNeetMarksObt);
          this.hasNeetMarksTot = this.qualList.some(q => !!q.StuNeetMarksTot);
          this.hasCeeRollNo = this.qualList.some(q => !!q.CEERollNo);
          this.hasCeeAppNo = this.qualList.some(q => !!q.CEEAppNo);
          this.hasCeeMarksObt = this.qualList.some(q => !!q.StuCEEMarksObt);
          this.hasCeeMarksTot = this.qualList.some(q => !!q.StuCEEMarksTot);
          this.hasEntranceRollNo = this.qualList.some(q => !!q.StuEntranceRollNo);
          this.hasEntranceEntrollNo = this.qualList.some(q => !!q.StuEntranceEntrollNo);
        }
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        this.isDivShow = false;
        this.qualList = [];
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }


    }, (ERROR: HttpErrorResponse) => {
      this.qualList = [];
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  percentage() {
    const StuMarksObt = this.qualificationDetailsForm.value.StuMarksObt;
    const StuMarksTot = this.qualificationDetailsForm.value.StuMarksTot;
    if (Number(StuMarksObt) > Number(StuMarksTot)) {
    this.qualificationDetailsForm.controls['StuMarksObt'].setErrors({ greaterThanTotal: true });
    this.qualificationDetailsForm.controls['StuPercent'].setValue('');
    return;
    } else {

    this.qualificationDetailsForm.controls['StuMarksObt']
      .setErrors(null);
  }
    var percentage = ((Number(StuMarksObt) / Number(StuMarksTot) * 100).toFixed(2));
    // this.qualificationDetailsForm.controls['StuPercent'].setValue(percentage);
    if (parseInt(percentage) == 100) {
      this.qualificationDetailsForm.controls['StuPercent'].setValue(100);
    }
    else {
      this.qualificationDetailsForm.controls['StuPercent'].setValue(percentage);
    }
  }

  back() {
    this.prev.emit(false);
    // this.submitButton =true ;
    this.qualificationDetailsForm.reset();
    this.updateButton = false;
    this.delReadOnly = false;
    this.deleteButton = false;
    this.nextButton = true;
    this.Noteligible = true;
    this.filename = '';
    this.prepopulateDataAvailable = false;
  }


  nextTab() {
    this.qualificationDetailsForm.reset();
    this.updateButton = false;
    this.deleteButton = false;
    this.submitButton = true;
    this.filename = '';
    this.prepopulateDataAvailable = false;
    if (this.qualList.length == 0) {
      this.SubmitQualificationDetails();
    } else {
      // this.checkEligibility()
      this.next.emit();
      this.updateButton = false;
      this.deleteButton = false;
      this.submitButton = true;
      this.nextButton = true;
    }

  }

  generateYears(startYear: number, endYear: number): number[] {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }



  onselectPrepopulateForDelete(e) {
    this.spinner.show();
    this.fetchCourseName(e.StuCoLvl)
    this.fetchPassYear();
    this.hideFileInput = true;
    let base64String: string = e.fileUploadData || '';

    if (e.StuResultStatus == false) {
      this.nextButton = false;
      this.resetButton = false;
    } else {
      this.nextButton = true;
      this.resetButton = true;
    }
   // this.uploadDoc = e.fileUploadData;

    // Store the file data in a component variable
    this.fileUploadData = base64String;  // Store the base64 string for later use

    let mimeType: string = base64String.split(';')[0];
    let fileExtension: string = '';
    if (mimeType.includes('pdf')) {
      fileExtension = 'pdf';
    } else if (mimeType.includes('jpeg') || mimeType.includes('jpg')) {
      fileExtension = 'jpg';
    } else if (mimeType.includes('png')) {
      fileExtension = 'png';
    } else {
      fileExtension = '';
    }

    if (!fileExtension) {
      this.filename = '';
      this.id = null;  // Don't show ID if no file is uploaded
    } else {
      this.id = e.StuQualId;
      this.filename = `${this.id}.${fileExtension}`;
    }
    this.prepopulateDataAvailable = true;
    if (e.StuResultStatus == false) {

      this.submitButton = false;
      this.nextButton = false;
      this.updateButton = false;
      this.resetButton = false;
    }
    else {
      this.nextButton = true;
      // this.submitButton =true;
      this.updateButton = true;
      this.resetButton = true;
    }
    this.submitButton = false;
    this.delReadOnly = true;
    // this.nextButton = true;
    this.updateButton = false;
    this.deleteButton = true;
    // this.resetButton = true;
    this.qualificationDetailsFormArray = [];
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e['StuQualId']);
    this.onYearSelect(e['StuPassYr'])
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible == true) {
          if (element.FormControlName === 'fileUploadData') {
            // this.qualificationDetailsForm.controls[element.FormControlName].setValue('', Validators.required);
          } else {
            if (element.FormRequired) {
              if (element.FormPattern == '') {
                this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName], Validators.required);
              } else {
                this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]);
              }
            } else {
              this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName]);
            }
          }
        }
      }

      );
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));

    });
  }

  deletedata(id) {
    this.updateButton = false;
    this.submitButton = true;
    // this.nextButton = true;
    this.deleteButton = false;
    this.resetButton = false;
    this.filename = '';
    this.prepopulateDataAvailable = false;
    this.hideFileInput = false;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        StuId: this.StudentPersonalId,
        StuQualId: id.StuQualId,
        LoginId: parseInt(sessionStorage.getItem('StudentRGID'))

      },
    };
    this.httpClient.delete(this.APIService + '/students/Qualification', options)
      .subscribe((s) => {
        // this.spinner.hide();http://192.168.1.102:8001/api/v1/students/Qualification
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.fetchQualDetailsForTable();
        this.dialogRef.afterClosed().subscribe(result => {
          this.qualificationDetailsForm.reset();
          this.delReadOnly = false;
          this.resultNotDec = false;
          this.isSaving = false;
        });
      }, (ERROR: HttpErrorResponse) => {
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });


  }

  openConformationModalBox() {
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Information'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.deletedata(this.qualificationDetailsForm.value);
      } else {
        // this.next.emit();

        this.updateButton = false;
        this.deleteButton = false;
        this.submitButton = true;
        this.nextButton = true;
        this.resetButton = false;
      }
    });
  }

  resetForm() {
    this.filename = ''
    this.updateButton = false;
    this.deleteButton = false;
    this.submitButton = true;
    this.nextButton = true;
    this.resetButton = false;
    this.delReadOnly = false;
    this.resultNotDec = false;
    this.prepopulateDataAvailable = false;
    this.filename = ''
    this.qualificationDetailsForm.reset();
    this.fetchPassYear();
  }

showbase64(data) {

  if (this.uploadDoc && this.uploadDoc.startsWith('data:')) {
    this.dialog.open(PdfviewerComponent, {
      width: "400px",
      height: "500px",
      data: this.uploadDoc
    });
    return;
  }

  if (data.fileUploadData) {

    this.spinner.show();

    let payload = {
      filePath: data.fileUploadData   
    };

    this.umsService.fetchDocument(payload).subscribe((res) => {
      this.spinner.hide();

      if (res.status) {
        this.dialog.open(PdfviewerComponent, {
          width: "400px",
          height: "500px",
          data: res.doc   
        });
      }
    });
  }
}
showbaseFile() {
    if (this.fileUploadData.startsWith('data:')) {
      const dialogRef3 = this.dialog.open(PdfviewerComponent,
        {
          width: "400px",
          height: "500px",
          data: this.fileUploadData,
          disableClose: true
        });
    } else if (!this.fileUploadData.startsWith('data:')) {
      let payload = {};
      payload['filePath'] = this.fileUploadData;
      this.umsService.fetchDocument(payload).subscribe((res) => {
        if (res.status) {
          this.spinner.hide()
          const dialogRef3 = this.dialog.open(PdfviewerComponent,
            {
              width: "400px",
              height: "500px",
              data: res.doc
            });
        }
        
      })
    }
  }

  showUploadedFile(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.fileUploadData,
        disableClose: true
      });
  }


  otherUniversity(item) {
    if (item.CdDesc == 'Other') {
      this.showotheruni = true;
    }
    else {
      this.showotheruni = false;
    }
  }

  checkEligibility() {
    this.spinner.show();
    let payload = {};
    payload['StudentId'] = parseInt(sessionStorage.getItem('StudentPersonalId'))
    payload['SessionNo'] = parseInt(sessionStorage.getItem('session'))
    payload['ExamId'] = 0
    payload['RegId'] = 0
    payload['RuleResult'] = 'A'
    payload['EligibilityFor'] = "PreAdmissionQualification";
    this.umsService.CheckExamEligibility(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.getEligibility()
      }
      else {
        this.next.emit();
        this.updateButton = false;
        this.deleteButton = false;
        this.submitButton = true;
        this.nextButton = true;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.next.emit();
      this.updateButton = false;
      this.deleteButton = false;
      this.submitButton = true;
      this.nextButton = true;
    })
  }

  getEligibility() {
    this.dialogRef = this.dialog.open(ExamEligibilityComponent, {
      width: '170vh',
      height: '85vh',
      disableClose: true,
      data: 'PreAdmissionQualification',
    });
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'Continue') {
        this.next.emit();
        this.updateButton = false;
        this.deleteButton = false;
        this.submitButton = true;
        this.nextButton = true;
      } else {
        this.submitButton = true;
        this.nextButton = true;
        // this.nextButton = false;
        // this.isSaving = true;
        this.fetchQualDetailsForTable();
        //  this.ngOnInit();
      }
    });
  }

  getCheck(e) {
    if (e.checked == true) {
      this.Noteligible = false;
    }
    else if (e.checked == false) {
      this.Noteligible = true;
    }
  }

  getcollege(CgCode) {
    const payload = {};
    payload['CgCode'] = CgCode
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeName = res.data[0].CgName;

    }, (ERROR: HttpErrorResponse) => {
      // this.collegedataList = [];
      this.spinner.hide();
    })
  }

  CheckOld(data) {
    const control = this.qualificationDetailsForm.get('StuCoLvl');
    if (data.CdDesc === this.courseLeveloptionone || data.CdDesc === this.courseLeveloptiontwo) {
      control?.setErrors({ sameLevel: true });
    } else {
      if (control?.hasError('sameLevel')) {
        const errors = { ...control.errors };
        delete errors['sameLevel'];
        control.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
  }

  getAdmittedData() {
    let payload = {}
    payload['FirstName'] = this.StuPersonal.StuFirstNameEng;
    payload['MotherName'] = this.StuPersonal.StuMothNameEng;
    payload['FatherName'] = this.StuPersonal.StuMidNameEng;
    payload['Gender'] = this.StuPersonal.StuGender;
    payload['DOB'] = this.StuPersonal.StuBirthDate;
    payload['MobNumber'] = this.StuPersonal.StuNumber;
    payload['CgCode'] = '';
    payload['CgName'] = this.collegeName;

    this.umsService.getAdmittedData(payload).subscribe((res) => {
      if (res.status) {
        this.OldStudent = true;
        this.qualificationDetailsFormArray['StuMigrationNo'][0]['FormRequired'] = false;
      }
      else {
        this.OldStudent = false;

      }
    })
  }
    prepopulationContact() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchContactDetails(payload).subscribe(res => {
      if (res.status) {
        this.contactDetails = res.data[0]
        if (res.data[0].StuNationality === 'OS') {
          this.umsService.studentProgressList['StudentReservation'] = 1;
        }
      } 
    }, (ERROR: HttpErrorResponse) => {
      
    })

  }
  async saveFiles(): Promise<any>  {
    const payload = {
          filePath: 'qualification_documents/' + parseInt(this.StudentPersonalId) +  '_' +  (this.qualificationDetailsForm.getRawValue().StuCoLvl + '_Marksheet').toLowerCase().replace(/ /g, '_'),
          base64: this.uploadDoc,
          StuId: this.StudentPersonalId
          };
    try{
      if(payload.filePath && payload.base64 && payload.StuId){
      const response = await this.umsService.saveFiles(payload).toPromise()
      return response
      }
      }
    catch (error) {
      console.log(error);
      throw error;
      }
    }
   getExt(base64String) {
  const match = base64String.match(/^data:(.*?);base64,/);
  if (!match) return "txt";

  const type = match[1];
  if (type.includes("png")) return "png";
  if (type.includes("jpeg")) return "jpeg";
  if (type.includes("jpg")) return "jpg";
  if (type.includes("pdf")) return "pdf";
  }
saveEntranceDetails() {
  const payload = {
    StuId: this.StudentPersonalId,
    StuCoLvl: this.qualificationDetailsForm.value.StuCoLvl,
    StuEntranceRollNo: this.qualificationDetailsForm.value.StuEntranceRollNo,
    StuEntranceEntrollNo: this.qualificationDetailsForm.value.StuEntranceEntrollNo
  };
   this.umsService.StudentEntranceDetails(payload).subscribe(
    (res: any) => {
      if (res.status) {
       console.log('Student Entrance Details Saved Successfully');
      } else {
        console.log('Failed to save Student Entrance Details');
      }
    },
    (err) => {
      console.log(err);
    }
  );
}
getStudentEntranceDetails() {
  const payload = {
    StuId: this.StudentPersonalId,
    StuCoLvl:this.qualificationDetailsForm.get('StuCoLvl')?.value
  };
  this.umsService.fetchStudentEntrance(payload).subscribe((res: any) => {
      if (res.status && res.data.length > 0) {
        const data = res.data[0];
        this.qualificationDetailsForm.patchValue({
          StuEntranceRollNo: data.StuEntranceRollNo,
          StuEntranceEntrollNo: data.StuEntranceEntrollNo
        });
        if (data.StuCoLvl == '6') {
          this.showPhD = true;
        }
      }
    }, (error) => {
      console.log(error);
    });
}
  saveMarksheet() {
  const payload = {
    StuId: this.StudentPersonalId,
    StuTopic: null,
    StuGuideName: null,
    WorkExperience:null,
    Marksheet: this.qualificationDetailsForm.value.Marksheet
  };

  this.umsService.StudentOtherDetails(payload).subscribe(res => {
    if (res.status) {
      this.qualificationDetailsForm.get('Marksheet')?.setValue(payload.Marksheet);
      console.log('Marksheet Saved Successfully');
    }
  }, (ERROR: HttpErrorResponse) => {
    console.log(ERROR);
  });

}
}